module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/appFullScreenView.html -->\n<div class="container">\n	<div id="fs-view-loader" data-nx-control="loader"></div>\n	<div data-nx-control="full-screen-content"></div>\n</div>\n';
}
return __p;
};
